var _linearGradient, _clipPath, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 67,
    height: 20,
    role: "img",
    "aria-label": "Render",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Render") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x2: 0,
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bbb",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.1
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 20,
    rx: 3,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 0,
    height: 20,
    fill: "#555"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 67,
    height: 20,
    fill: "#4c1"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 20,
    fill: "url(#s)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    textAnchor: "middle",
    fontFamily: "Verdana,Geneva,DejaVu Sans,sans-serif",
    textRendering: "geometricPrecision",
    fontSize: 110
  }, /*#__PURE__*/React.createElement("image", {
    x: 5,
    y: 3,
    width: 14,
    height: 14,
    xlinkHref: "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJ3aGl0ZSIgcm9sZT0iaW1nIiB2aWV3Qm94PSIwIDAgMjQgMjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHRpdGxlPlJlbmRlcjwvdGl0bGU+PHBhdGggZD0iTTEzLjU4NiAwdjMuMTcySDcuNTIzYTQuNTI4IDQuNTI4IDAgMCAwLTMuMDE4IDEuMzA1IDQuNDk4IDQuNDk4IDAgMCAwLTEuMzMzIDIuOTl2MTEuMzI2SDBWNy41MDlhNy40NzIgNy40NzIgMCAwIDEgMi4yMDQtNS4zMDVBNy40NzEgNy40NzEgMCAwIDEgNC41ODguNTg5IDcuNDMyIDcuNDMyIDAgMCAxIDcuNTEgMFptNS4yMDcgMHYzLjE1OEgxNS42MlYwWk0yNCAwdjMuMTU4aC0zLjE3MlYwWm0wIDUuMjA3djMuMTcyaC0zLjE3MlY1LjIwN1ptMCA1LjIwN3YzLjE3MmgtMy4xNzJ2LTMuMTcyWm0wIDUuMjA3djMuMTcyaC0zLjE3MlYxNS42MlptMCA1LjIwN1YyNGgtMy4xNzJ2LTMuMTcyWm0tNS4yMDcgMFYyNEgxNS42MnYtMy4xNzJabS01LjIwNyAwVjI0aC0zLjE3MnYtMy4xNzJabS01LjIwNyAwVjI0SDUuMjA3di0zLjE3MlptLTUuMjIxIDBWMjRIMHYtMy4xNzJaIi8+PC9zdmc+"
  }), /*#__PURE__*/React.createElement("text", {
    "aria-hidden": "true",
    x: 425,
    y: 150,
    fill: "#010101",
    fillOpacity: 0.3,
    transform: "scale(.1)",
    textLength: 390
  }, "Render"), /*#__PURE__*/React.createElement("text", {
    x: 425,
    y: 140,
    transform: "scale(.1)",
    fill: "#fff",
    textLength: 390
  }, "Render"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRender);
export default __webpack_public_path__ + "static/media/render.ed5b02252e03fdaed3b29351fafe9618.svg";
export { ForwardRef as ReactComponent };